<template>
    <div class="card-list-item" tabindex="-1">
        <div class="main">
            <dynamic-display :load-data-api="getLoadDataApi()" @loadEnd="onLoadEnd" :load-data-on-created="true"
                             ref="dynamicDisplay" class="dynamic-display">
                <template v-slot:showResultsContainer>
                    <template v-if="itemDetail">
                        <div class="line">
                            <div class="left highlight" :title="itemDetail.biography">{{ itemDetail.biography }}</div>
                            <div class="text-gray right">Since {{
                                    itemDetail.positionSince
                                }}
                            </div>
                        </div>
                        <div class="line">
                            <div class="left">
                                <span v-if="itemDetail.stockCode">{{ itemDetail.stockCode }} &bullet; </span>
                                {{ itemDetail.companyName }}<span
                                    class="text-gray"> ({{ itemDetail.companyId }})</span></div>
                            <div class="text-gray text-uppercase text-nowrap">{{ itemDetail.source }}</div>
                        </div>
                        <div class="line">
                            <span class="text-gray">Index ID: {{ indexId }}</span>
                        </div>
                    </template>
                    <span v-else>Index ID "{{ indexId }}" doesn't exist in AdminHK</span>
                </template>
            </dynamic-display>
        </div>
        <div class="controls">
            <button class="pure" @click="removeItem"><i class="gf gf-close"></i></button>
        </div>
    </div>
</template>

<script>
import DynamicDisplay from "@/components/DynamicDisplay";
import {getPersonBioData} from "@/apis";

export default {
    name: "PersonBioRow",
    components: {DynamicDisplay},
    props: {
        indexId: Number,
    },
    data() {
        return {
            itemDetail: null,
        }
    },
    methods: {
        getLoadDataApi() {
            return getPersonBioData.bind(null, this.indexId);
        },
        onLoadEnd(showingResults, results) {
            if (results) {
                this.itemDetail = this.transformItemDetail(results);
            } else {
                this.itemDetail = null;
            }
        },
        transformItemDetail(itemDetail) {
            const {Biography, Position_since, Gekko_name_en, Gekko_name_ch, Source, Stock_code, Gekko_id_company} = itemDetail;
            let biography, positionSince, stockCode, companyName, companyId, source;

            biography = Biography;

            positionSince = Position_since || '?';

            stockCode = Stock_code;

            companyName = Gekko_name_en || Gekko_name_ch;

            companyId = Gekko_id_company;

            source = Source;

            return {
                biography,
                positionSince,
                stockCode,
                companyName,
                companyId,
                source,
            }
        },
        removeItem() {
            this.$emit('removeItem', this.indexId);
        },
        focus() {
            this.$el.focus();
        }
    }
}
</script>

<style scoped lang="scss">
@import "../assets/variables";
</style>
